import { type TipoCompetenzaSecondariaDTO } from '@framework/api-client/api/users/schemas/tipoCompetenzaSecondariaDTO.ts';
import {
  getGetTipoCompetenzaSecondariaQueryOptions,
  getTipoCompetenzaSecondaria,
} from '@framework/api-client/api/users/tipo-competenza-secondaria-controller/tipo-competenza-secondaria-controller.ts';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';

/**
 * AsyncSelect riutilizzabile per la selezione di un Tipo Competenza
 * Secondaria. Carica i dati dall'API (endpoint paginato) con ricerca per
 * denominazione. Riusabile ovunque serva scegliere un
 * `idTipoCompetenzaSecondaria` (config comunicazioni, widget Selezione
 * Competenza, layer mappa).
 */
export function SecondaryCompetenceTypeAsyncSelect(
  props: IBaseAsyncSelectInputProps,
) {
  return (
    <AsyncSelectInput
      {...props}
      queryFn={getTipoCompetenzaSecondaria}
      initialParams={{ ordinamenti: ['denominazione'] }}
      queryOptions={getGetTipoCompetenzaSecondariaQueryOptions}
      searchByField="denominazione"
      asOption={(type: TipoCompetenzaSecondariaDTO) => ({
        value: String(type.id),
        label: type.denominazione ?? type.codice ?? String(type.id),
      })}
    />
  );
}
